// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../../atom/Atom_Cell.bs.js";
import * as Atom_Logo from "../../atom/Atom_Logo.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as UseToggle from "../../../hook/UseToggle.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Particle_Css from "../../particle/Particle_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Organism_Newsletter from "./Organism_Newsletter.bs.js";
import * as Particle_Spacer_Css from "../../particle/Particle_Spacer_Css.bs.js";
import * as Particle_Accessibility from "../../particle/Particle_Accessibility.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";

function makeStyle(icon) {
  if (icon !== undefined) {
    return {
            TAG: /* Footer */7,
            _0: {
              TAG: /* Social */1,
              _0: icon
            }
          };
  } else {
    return {
            TAG: /* Footer */7,
            _0: /* Link */2
          };
  }
}

function Organism_LinksSection$Links(Props) {
  var items = Props.items;
  var titleKey = Props.titleKey;
  var showPrivacyCenter = Props.showPrivacyCenter;
  if (items !== undefined && items.length !== 0) {
    return Belt_Array.mapWithIndex(items, (function (i, item) {
                  if (item.TAG === /* Link */0) {
                    var label = item._0;
                    if (label === undefined) {
                      return null;
                    }
                    var target = item._3;
                    if (target === undefined) {
                      return null;
                    }
                    var tmp = {
                      href: Curry._1(Type_String.Href.toString, item._2),
                      label: Curry._1(Type_String.Footer.Label.toString, label),
                      style: makeStyle(item._1),
                      target: target
                    };
                    if (item._4 !== undefined) {
                      tmp.rel = Caml_option.valFromOption(item._4);
                    }
                    return React.createElement(Atom_Cell.make, {
                                kind: /* ItemList */4,
                                children: React.createElement(Atom_Cta.Link.make, tmp),
                                key: titleKey + String(i)
                              });
                  }
                  var label$1 = item._0;
                  if (label$1 !== undefined) {
                    return React.createElement(Atom_Cell.make, {
                                kind: /* ItemList */4,
                                children: React.createElement(Atom_Cta.Button.make, {
                                      label: Curry._1(Type_String.Footer.Label.toString, label$1),
                                      onClick: showPrivacyCenter,
                                      style: makeStyle(item._1)
                                    }),
                                key: titleKey + String(i)
                              });
                  } else {
                    return null;
                  }
                }));
  } else {
    return null;
  }
}

var Links = {
  makeStyle: makeStyle,
  make: Organism_LinksSection$Links
};

function getLinkSectionRules(status) {
  if (status) {
    return Particle_Screen_Ds.make(undefined, undefined, [CssJs.display(CssJs.flexBox)], undefined, undefined, [CssJs.display(CssJs.none)]);
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, [CssJs.display(CssJs.flexBox)], undefined, undefined, []);
  }
}

function getSpacerRules(status) {
  if (status) {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined));
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeNone(undefined)), undefined, undefined, Particle_Spacer_Ds.make("S", "None", "L", "None", undefined));
  }
}

var gridGapValue = Particle_Css.spacerSizeInside("L");

var wrapperRules = Particle_Screen_Ds.make(undefined, undefined, [
      CssJs.gridGap(gridGapValue),
      CssJs.display("grid"),
      CssJs.gridTemplateAreas({
            NAME: "areas",
            VAL: {
              hd: "logo links .",
              tl: /* [] */0
            }
          })
    ], [
      CssJs.gridGap(gridGapValue),
      CssJs.display("flex"),
      CssJs.flexDirection("row")
    ], undefined, []);

var logoRules = Particle_Screen_Ds.make(undefined, undefined, [CssJs.display(CssJs.flexBox)], Particle_Spacer_Css.toCss(Particle_Spacer_Ds.makeRight("S")), undefined, [
      CssJs.display(CssJs.none),
      CssJs.gridArea({
            NAME: "ident",
            VAL: "logo"
          })
    ]);

var linksRules = Particle_Screen_Ds.make(undefined, undefined, [
      CssJs.gridArea({
            NAME: "ident",
            VAL: "links"
          }),
      CssJs.gridGap(gridGapValue),
      CssJs.display("grid"),
      CssJs.gridTemplateAreas({
            NAME: "areas",
            VAL: {
              hd: "area_1 . area_2",
              tl: {
                hd: "area_3 . area_4",
                tl: {
                  hd: "newsletter newsletter newsletter",
                  tl: /* [] */0
                }
              }
            }
          })
    ], [
      CssJs.display("flex"),
      CssJs.flexDirection("row")
    ], undefined, []);

var Styles = {
  getLinkSectionRules: getLinkSectionRules,
  getSpacerRules: getSpacerRules,
  gridGapValue: gridGapValue,
  wrapperRules: wrapperRules,
  logoRules: logoRules,
  linksRules: linksRules
};

function Organism_LinksSection$Title(Props) {
  var title = Props.title;
  var href = Props.href;
  var onClick = Props.onClick;
  var status = Props.status;
  var screenSize = Props.screenSize;
  var isExpanded = status ? false : true;
  var title$1;
  var exit = 0;
  if (typeof screenSize === "object") {
    var variant = screenSize.NAME;
    if (variant === "XS" || variant === "S") {
      title$1 = React.createElement(Atom_Cta.Button.make, {
            accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, isExpanded, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
            label: title,
            onClick: onClick,
            style: {
              TAG: /* Footer */7,
              _0: {
                TAG: /* Title */2,
                _0: status
              }
            }
          });
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    title$1 = href !== undefined ? React.createElement(Atom_Cta.Link.make, {
            href: Curry._1(Type_String.Href.toString, href),
            label: title,
            style: {
              TAG: /* Footer */7,
              _0: /* TitleLink */3
            }
          }) : React.createElement(Atom_Text.make, {
            children: title,
            kind: "span",
            style: Atom_Text_Ds.Footer.title
          });
  }
  return React.createElement(Atom_Row.make, {
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("Zero")), undefined, undefined, Particle_Spacer_Ds.makeLeft("S")),
              children: title$1
            });
}

var Title = {
  make: Organism_LinksSection$Title
};

function Organism_LinksSection$LinkSection(Props) {
  var title = Props.title;
  var titleKey = Props.titleKey;
  var href = Props.href;
  var items = Props.items;
  var area = Props.area;
  var screenSize = Props.screenSize;
  var showPrivacyCenter = Props.showPrivacyCenter;
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var status = match.state;
  return React.createElement(Atom_Column.make, {
              area: area,
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeNone(undefined)), undefined, undefined, Particle_Spacer_Ds.makeBottom("S")),
              children: null,
              innerSpace: Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "None"),
              kind: /* ItemList */4
            }, title !== undefined ? React.createElement(Organism_LinksSection$Title, {
                    title: Curry._1(Type_String.Footer.Title.toString, title),
                    href: href,
                    onClick: match.toggle,
                    status: status,
                    screenSize: screenSize
                  }) : null, React.createElement(Atom_Column.make, {
                  blockSpace: getSpacerRules(status),
                  children: React.createElement(Organism_LinksSection$Links, {
                        items: items,
                        titleKey: titleKey,
                        showPrivacyCenter: showPrivacyCenter
                      }),
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S"),
                  kind: /* List */5,
                  rules: getLinkSectionRules(status),
                  width: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.em(10))
                }));
}

var LinkSection = {
  make: Organism_LinksSection$LinkSection
};

function Organism_LinksSection(Props) {
  var columnLinks = Props.columnLinks;
  var screenSize = Props.screenSize;
  var newsletter = Props.newsletter;
  var showPrivacyCenter = Props.showPrivacyCenter;
  var newsletterSource = Props.newsletterSource;
  var columnLinks$1 = columnLinks !== undefined ? Belt_Array.mapWithIndex(columnLinks, (function (i, param) {
            var title = param.title;
            var key = Curry._1(Type_String.Footer.Title.toString, Belt_Option.getWithDefault(title, Curry._1(Type_String.Footer.Title.make, Uuid.v4())));
            return React.createElement(Organism_LinksSection$LinkSection, {
                        title: title,
                        titleKey: key,
                        href: param.href,
                        items: param.items,
                        area: "area_" + String(i + 1 | 0),
                        screenSize: screenSize,
                        showPrivacyCenter: showPrivacyCenter,
                        key: key
                      });
          })) : null;
  var mainSpacer = Particle_Spacer_Ds.makeVertical("XS");
  var tmp = {
    labels: newsletter,
    style: /* Footer */0
  };
  if (newsletterSource !== undefined) {
    tmp.source = Caml_option.valFromOption(newsletterSource);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Column.make, {
                  blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, mainSpacer),
                  children: null,
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS"),
                  rules: wrapperRules
                }, React.createElement(Atom_Cell.make, {
                      blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("XL")),
                      height: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.px(200)),
                      children: null,
                      rules: logoRules
                    }, React.createElement(Atom_Logo.make, {
                          logo: {
                            NAME: "ArteVerticalLogo",
                            VAL: "Footer"
                          }
                        }), ""), React.createElement(Atom_Column.make, {
                      children: null,
                      justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.spaceBetween),
                      kind: /* List */5,
                      rules: linksRules,
                      width: Particle_Screen_Constants.oneHundredPctWidth
                    }, columnLinks$1, React.createElement(Organism_Newsletter.make, tmp))));
}

var make = Organism_LinksSection;

export {
  Links ,
  Styles ,
  Title ,
  LinkSection ,
  make ,
}
/* gridGapValue Not a pure module */
